/*
 * @Author: Narcissus
 * @Date: 2022-12-05 11:08:59
 * @LastEditTime: 2022-12-17 10:42:55
 * @LastEditors: Narcissus
 * @Description:
 * @FilePath: \analysis_chemical_shift_table\ui\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/global.css';

Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js